/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of ToyTrendsList
 * Alfapeople -Customisation object -For ToyTrendsList page
 */

import React, { Component } from 'react';

export interface IToy {
  toyImage?: string;
  toyDescription?: string;
  toyLink?: string;
}
/**
 *
 * ToyTrendsList component
 * @extends Component
 */
export class ToyTrendsList extends Component {
  private readonly toys: IToy[] = [
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDxPk',
      toyDescription: '4 unboxing worthy toys',
      toyLink: '/four-unboxing-worthy-toys',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1Y',
      toyDescription: 'it’s slime time! 2 slimy toys we love ',
      toyLink: '/slimy-toys',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqJ',
      toyDescription: 'level up the fun! top 2 video game toys',
      toyLink: '/top-two-video-game-toys',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDxPb',
      toyDescription: 'these two Frozen 2 toys are worth melting for',
      toyLink: '/frozen-toys',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-sm-12'>
            <h1 className='toy-heading'>toy trends</h1>
          </div>
          {this.toys.map((p) => (
            <div className='col-lg-4 col-md-6 col-sm-12'>
              <div className='row product-row'>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='img-link'>
                    <img
                      className='img-responsive'
                      src={p.toyImage}
                      alt={p.toyDescription}
                    />
                  </a>
                </div>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='toy-link'>
                    {p.toyDescription}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default ToyTrendsList;
